import React from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4 } from "../common/ui";

type PatientEmergency = { first_name?: string; last_name?: string; gender?: string };

type ModalEmergencyV4Props = {
  patient?: PatientEmergency | null;
  error?: unknown;
  onChange: (key: keyof PatientEmergency, value: string) => void;
  onClear: () => void;
  onSave: () => void;
  onClose: () => void;
};

const EMERGENCY_GENDERS = [
  { value: "M", label: "ชาย" },
  { value: "F", label: "หญิง" },
  { value: "CM", label: "เด็กชาย" },
  { value: "CF", label: "เด็กหญิง" },
] as const;

/** เปิดประวัติฉุกเฉิน: ชื่อ นามสกุล เพศ */
const ModalEmergencyV4 = (props: ModalEmergencyV4Props) => {
  // Handler
  const handleChangeFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange("first_name", e.target.value);
  };

  const handleChangeLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange("last_name", e.target.value);
  };

  // Render
  return (
    <ModalV4 title="เปิดประวัติฉุกเฉิน" width={560} onClose={props.onClose}>
      <div className="hv4-reg-modal-body">
        <AlertV4 tone="danger" error={props.error} />
        <FieldV4 label="ชื่อ" htmlFor="hv4-reg-em-first">
          <input
            id="hv4-reg-em-first"
            className="hv4-input"
            value={props.patient?.first_name ?? ""}
            onChange={handleChangeFirstName}
          />
        </FieldV4>
        <FieldV4 label="นามสกุล" htmlFor="hv4-reg-em-last">
          <input
            id="hv4-reg-em-last"
            className="hv4-input"
            value={props.patient?.last_name ?? ""}
            onChange={handleChangeLastName}
          />
        </FieldV4>
        <div role="radiogroup" aria-label="เพศ">
          <span className="hv4-label">เพศ *</span>
          <div className="hv4-reg-gender">
            {EMERGENCY_GENDERS.map((gender) => (
              <label key={gender.value}>
                <input
                  type="radio"
                  name="hv4-reg-em-gender"
                  value={gender.value}
                  checked={props.patient?.gender === gender.value}
                  onChange={() => props.onChange("gender", gender.value)}
                />
                {gender.label}
              </label>
            ))}
          </div>
        </div>
      </div>
      <div className="hv4-reg-modal-foot">
        <ButtonV4 variant="ghost" onClick={props.onClear}>
          ล้าง
        </ButtonV4>
        <ButtonV4 variant="ok" onClick={props.onSave}>
          บันทึก
        </ButtonV4>
      </div>
    </ModalV4>
  );
};

ModalEmergencyV4.displayName = "ModalEmergencyV4";

export default ModalEmergencyV4;
